import React, { memo } from 'react';
import { Instagram, ArrowRight } from 'lucide-react';
import { brandInfo } from '../data/mock';

const GalleryImage = memo(({ src, alt }) => (
  <div className="gallery-item">
    <img src={src} alt={alt} loading="lazy" decoding="async" />
  </div>
));

const CommunitySection = memo(() => {
  const images = [
    { src: '/images/ig1.png', alt: 'Instagram post 1' },
    { src: '/images/ig2.png', alt: 'Instagram post 2' },
    { src: '/images/ig3.png', alt: 'Instagram post 3' },
    { src: '/images/ig4.png', alt: 'Instagram post 4' },
  ];

  return (
    <section className="community-section">
      <div className="section-container">
        <div className="community-content">
          <div className="community-text">
            <span className="section-label">ZAJEDNICA</span>
            <h2 className="community-title">
              PRIDRUŽITE SE<br />
              <span className="title-accent">NAŠOJ ZAJEDNICI</span>
            </h2>
            <p className="community-description">
              Pratite našu Instagram stranicu za sve novosti, 
              inspirativne recepte i ekskluzivne ponude.
            </p>
            <a
              href={brandInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="community-cta"
            >
              <Instagram size={20} />
              Pratite sada
              <ArrowRight size={16} />
            </a>
          </div>

          <div className="community-gallery">
            {images.map((img, index) => (
              <GalleryImage key={index} src={img.src} alt={img.alt} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
});

export default CommunitySection;
